import {
  PassouFalhouEnum,
  PodeNaoPodeEnum,
} from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { calculateResultadoPergunta18 } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-18/utils-consultaSeguimentoPergunta18'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { ReactNode } from 'react'
import { isUndefinedOrNull } from 'util/checks'

import { HistoricoMChatHeaderTableItem } from '../components/HistoricoMchatHeaderTableItem'
import { HistoricoMChatPerguntaSection } from '../components/HistoricoMchatPerguntaSection'
import { HistoricoMChatResultadoParcialTableItem } from '../components/HistoricoMChatResultadoParcialTableItem'
import { HistoricoMChatSimpleHorizontalTableItem } from '../components/HistoricoMChatSimpleHorizontalTableItem'
import { HistoricoMChatSimpleVerticalTableItem } from '../components/HistoricoMChatSimpleVerticalTableItem'
import { HistoricoMchatTwoColumnsEvenlyTableItem } from '../components/HistoricoMchatTwoColumnsEvenlyTableItem'
import { getOutroOuPergunta, getOutroOuResposta } from '../utils-HistoricoMchatRf'
import { convertAplicacaoPergunta18 } from './converter-HistoricoMchatPergunta18'

const PODE_NAO_PODE_TEXTO: Record<PodeNaoPodeEnum, string> = {
  [PodeNaoPodeEnum.PODE]: 'A criança pode compreender uma ordem simples, sem sinais não-verbais.',
  [PodeNaoPodeEnum.NAO_PODE]: 'A criança não pode compreender uma ordem simples, sem sinais não-verbais.',
}

const breakText = (texto: string): ReactNode => {
  const index = texto.indexOf('?')
  if (index === -1) return texto

  const primeiraParte = texto.slice(0, index + 1)
  const restante = texto.slice(index + 1).replace(/^[.\s]+/, '')
  if (!restante) return texto

  return (
    <>
      {`"${primeiraParte}`}
      <br />
      {`${restante}"`}
    </>
  )
}

interface HistoricoMChatRfPergunta18Props {
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
}

export const HistoricoMChatRfPergunta18 = (props: Readonly<HistoricoMChatRfPergunta18Props>) => {
  const { aplicacoes } = props

  const converted = convertAplicacaoPergunta18(aplicacoes)
  if (converted === null) return null

  const { header, podeNaoPode, cenariosComDica, cenariosSemDica, perguntaAdicionalSemDica, model } = converted
  if (isUndefinedOrNull(header)) return null

  const resultado = calculateResultadoPergunta18(model)

  return (
    <HistoricoMChatPerguntaSection>
      <HistoricoMChatHeaderTableItem
        numeroPergunta='18'
        title={header.textoPergunta}
        value={header.stPassou}
        pergunta={undefined}
      />

      {podeNaoPode && (
        <HistoricoMChatSimpleVerticalTableItem
          pergunta='“Por favor, dê um exemplo de como ele compreendeu você.”'
          resposta={undefined}
        />
      )}
      {podeNaoPode && (
        <HistoricoMChatSimpleHorizontalTableItem
          pergunta='O exemplo indica que:'
          resposta={model.PERGUNTA_18_PODE_NAO_PODE ? PODE_NAO_PODE_TEXTO[model.PERGUNTA_18_PODE_NAO_PODE] : undefined}
        />
      )}

      {cenariosComDica.map((aplicacao) => (
        <HistoricoMChatSimpleVerticalTableItem
          key={aplicacao.pergunta}
          pergunta={breakText(getOutroOuPergunta(aplicacao))}
          resposta={getOutroOuResposta(aplicacao)}
        />
      ))}

      {perguntaAdicionalSemDica && (
        <HistoricoMChatSimpleVerticalTableItem
          pergunta={getOutroOuPergunta(perguntaAdicionalSemDica)}
          resposta={getOutroOuResposta(perguntaAdicionalSemDica)}
        />
      )}

      {cenariosSemDica.length > 0 && (
        <HistoricoMChatSimpleVerticalTableItem
          pergunta='“Quando a situação não dá nenhuma dica, ele consegue seguir uma ordem? Por exemplo...”'
          resposta={undefined}
        />
      )}

      {cenariosSemDica.length > 0 && <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={cenariosSemDica} />}

      {resultado && <HistoricoMChatResultadoParcialTableItem valor={resultado === PassouFalhouEnum.PASSOU} />}
    </HistoricoMChatPerguntaSection>
  )
}
